import Card from '../components/Card';
import Layout from '../components/layout/Layout';

const Index = () => (
  <Layout> 
    <section id="uebersicht" className="pt-20 md:pt-20">
      <div className="container mx-auto px-8 lg:flex">
        <div className="text-center lg:text-left y-5">
          <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold leading-none">
            Pressebilder
          </h1>
          <p className="text-xl lg:text-2xl mt-6 font-light">
            Die Bilder sind im Zusammenhang mit der Berichterstattung unter Angabe des Copyrights frei zum Abdruck.
          </p>
        </div>   
      </div>
    </section>
    <section id="anlaesse" className="pt-20 md:pt-20">
      <div className="container mx-auto text-center">
        <div className="container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Card className="" id="arlesheim">
            <p className="font-semibold text-xl">Trafoturm</p>
            <p className="mt-4">Umbau eines alten Trafoturms zu einem «Artenschutzturm» für Fledermäuse, Vögel und Co. (Gipsi Zeglingen).</p>
            <p className="mt-4">Autor: Urs Wolfsberger</p>
            <p className="mt-4">
              <a href="Trafoturm_cr_Urs_Wolfsberger.jpg"><img className="w-full rounded border-2" src="Trafoturm_cr_Urs_Wolfsberger.jpg"/></a>            
            </p>
          </Card>
          <Card className="" id="arlesheim">
            <p className="font-semibold text-xl">Baumpflanzung</p>
            <p className="mt-4">Pflanzung einer Traubeneiche (Rünenberg).</p>
            <p className="mt-4">Autor: Thomas Zumbrunn</p>
            <p className="mt-4">
              <a href="Baumpflanzung_cr_Thomas_Zumbrunn.jpg"><img className="w-full rounded border-2" src="Baumpflanzung_cr_Thomas_Zumbrunn.jpg"/></a>            
            </p>
          </Card>
          <Card className="" id="arlesheim">
            <p className="font-semibold text-xl">Wieselburg</p>
            <p className="mt-4">Bau einer grossen Wieselburg aus Kalk-Bruchsteinen (Rünenberg).</p>
            <p className="mt-4">Autor: Thomas Zumbrunn</p>
            <p className="mt-4">
              <a href="Wieselburg_cr_Thomas_Zumbrunn.jpg"><img className="w-full rounded border-2" src="Wieselburg_cr_Thomas_Zumbrunn.jpg"/></a>            
            </p>
          </Card>                    
        </div>
      </div>
    </section>
  </Layout>
);

export default Index;
